<script setup>
import { useLocale } from "vuetify";
import { usePage, Link } from "@inertiajs/vue3";
import { onMounted, nextTick, ref, provide, watch, onUnmounted } from "vue";
import { useLang } from "@/stores/lang.js";
import { formatNumber, getCookie, removeCookie, getOrderFlavorText } from "@/HelperFunction.js";
import { toast } from "vuetify-sonner";
import Lang from "@/Pages/home/Lang.vue";
import { useDarkMode } from "@/stores/darkMode.js";
import { useDataStore } from "@/stores/DataStore";
import Filter from "@/Components/Filter.vue";
import Item from "@/Components/Item.vue";
const store = useDataStore();
const { t } = useLocale();
const localeLang = useLang();
const page = usePage().props;
const darkStore = useDarkMode();
const props = defineProps({
    category: {
        type: Object,
        default: null,
    },
    topItems: {
        type: Array,
        default: [],
    },
    first: {
        type: Boolean,
        default: false,
    },
});

const showItem = ref(false);

function closeModal() {
    showItem.value = false;
    updateStep(1);
}

provide("closeModal", closeModal);
const showOrders = ref(false);
const qrAlert = ref(false);
const invoice = ref(false);
onMounted(() => {
    store.fetchJoinData();
    startInvoiceSSE();
    window.addEventListener("scroll", handleScroll, { passive: true });
    nextTick(() => {
        handleScroll();
    });
    qrAlert.value = getCookie("qrcode");
    invoice.value = Number(getCookie("invoice"));
    if (getCookie("resetOrder")) {
        store.orders = {};
        comment.value = null;
        removeCookie("resetOrder");
    }
    store.prosTotal();
});

function removeOrder(key) {
    delete store.orders[key];
    store.prosTotal();
}
const isWaitingTable = ref(false);
function sendAlert(data) {
    // console.log(data);

    isWaitingTable.value = true;
    axios.post(route("send-alert"), {
        type: data.id,
        data: {
            join_ku: data.join_ku,
            color: data.color,
        },
        invoiceId: getCookie("invoice"),
        tableId: getCookie("tableId"),
    })
        .then((response) => {
            if (response.data.msg == 1) {
                setTimeout(() => {
                    isWaitingTable.value = false;
                }, 60000);
                toast(t("$vuetify.orderSent"), {
                    cardProps: {
                        color: "orderBtn",
                        class: "text-right",
                    },
                    progressBar: true,
                });
            } else {
                toast(t("$vuetify.errorAlert"), {
                    cardProps: {
                        color: "pink",
                        class: "text-right",
                    },
                    progressBar: true,
                });
            }
        });
}

const comment = ref(null);
const loading = ref(false);
const phone = ref(localStorage.getItem("phone") ?? "");
const name = ref(localStorage.getItem("name") ?? "");
const address = ref(localStorage.getItem("address") ?? "");
const phoneRules = [
    (v) => !!v || t("$vuetify.phoneRequired"),
    (v) => /^[0-9]{10,12}$/.test(v) || t("$vuetify.phoneValid"),
];
const nameRules = [(v) => !!v || t("$vuetify.nameRequired")];
const addressRules = [(v) => !!v || t("$vuetify.addressRequired")];

const pushData = ref({});
const pushNote = ref("");
const feedbackDialog = ref(false);
const feedbackDialogClosed = ref(false);
provide("closeFeedbackDialog", () => {
    // feedbackDialogClosed.value = true;
    feedbackDialog.value = false;
});
function startInvoiceSSE(newInvoiceId = null) {
    const currentInvoiceId = getCookie("invoice");
    const invoiceId = newInvoiceId || currentInvoiceId;

    if (!invoiceId) {
        console.warn("No invoice ID found");
        return;
    }

    // If we're already listening to a different invoice, leave that channel
    if (currentInvoiceId && currentInvoiceId != invoiceId) {
        window.Echo.leaveChannel('invoices.' + currentInvoiceId);
    }

    window.Echo.channel('invoices.' + invoiceId)
        .listen('.InvoiceUpdated', (e) => {
            const res = e.data;
            pushData.value = res.push;
            pushNote.value = res.note;
            if (pushData.value && pushData.value.status_id == 8 && localStorage.getItem("sendFeedback_" + invoiceId) != "1" && !feedbackDialogClosed.value) {
                feedbackDialog.value = true;
            }
        });
}

onUnmounted(() => {
    const invoiceId = getCookie("invoice");
    if (invoiceId) {
        window.Echo.leaveChannel('invoices.' + invoiceId);
    }
});
let formValid = ref("");
const showMsg = ref("");
const submit = async (event) => {
    const results = await event;
    if (results.valid) {
        const tableId = getCookie("tableId");
        const uid = getCookie("uid");
        const invoiceId = getCookie("invoice");
        const oneSignalId = localStorage.getItem("oneSignalKhalId") ?? "";

        // if (!tableId) {
        //     toast(t("$vuetify.scanCode"), {
        //         cardProps: {
        //             color: 'pink',
        //             class: 'text-right',
        //         },
        //         progressBar: true,
        //     });
        //     return;
        // }

        loading.value = true;
        showMsg.value = t("$vuetify.pleaseWait");

        try {
            localStorage.setItem("phone", phone.value);
            localStorage.setItem("address", address.value);
            localStorage.setItem("name", name.value);

            const response = await axios.post(route("set.orders"), {
                invoiceId,
                comment: comment.value,
                orders: store.orders,
                name: name.value,
                phone: phone.value,
                address: address.value,
                token: oneSignalId,
                uid,
                tableID: tableId,
            });

            if (response.data.id) {
                startInvoiceSSE(response.data.id);
                localStorage.setItem("orders", JSON.stringify(store.orders));
                store.orders = {};
                comment.value = null;
                store.prosTotal();
                showMsg.value = t("$vuetify.orderSent");
                toast(t("$vuetify.orderSent"), {
                    cardProps: {
                        color: "green",
                        class: "text-right",
                    },
                    progressBar: true,
                });
            } else {
                throw new Error("Invalid response from server");
            }
        } catch (error) {
            console.error('Submit error:', error);
            const errorMessage = error.response?.data?.error || 'errorAlert';
            toast(t(`$vuetify.${errorMessage}`), {
                cardProps: {
                    color: "red",
                    class: "text-right",
                },
                progressBar: true,
            });
            showMsg.value = t(`$vuetify.${errorMessage}`);
        } finally {
            loading.value = false;
        }
    }
};
const invoiceData = ref(null);

function fnShowInvoice() {
    invoiceData.value = null;
    if (getCookie("invoice")) {
        axios
            .post(route("get-invoice"), {
                invoiceId: getCookie("invoice"),
                tableId: getCookie("tableId"),
            })
            .then((response) => {
                if (response.data.data != null) {
                    invoiceData.value = response.data.data;
                }
            });
    }
    showOrders.value = true;
}

// provide("ToOrder", ToOrder);
// provide("orders", orders);

const step = ref(1);

function updateStep(stp = 1) {
    window.location.hash = `step=${stp}`;
    step.value = stp;
}

watch(step, (step) => {
    if (step < 2) {
        showItem.value = false;
    }
});

const localSet = ref(false);

function fnShowLang(val) {
    localSet.value = val;
}

provide("fnShowLang", fnShowLang);
const favorites = ref(JSON.parse(localStorage.getItem("favorites")) ?? []);
const modelFavorate = ref(false);

function toggleHeart(item) {
    const index = favorites.value.findIndex((fav) => fav.id === item.id);
    // let type = 1;
    if (index !== -1) {
        favorites.value.splice(index, 1);
        // type = -1;
    } else {
        favorites.value.push(item);
    }
    localStorage.setItem("favorites", JSON.stringify(favorites.value));
}

function isHeart(id) {
    return favorites.value.some((item) => item.id === id);
}
provide("toggleHeart", toggleHeart);
provide("isHeart", isHeart);
const cateTop = ref(0);

const headerOffset = 56 + 75; // 60px for top position + 64px for categories height

let isScrollingProgrammatically = false;
let scrollTimeout = null;
const selectedCategory = ref(null);
const slideGroup = ref(null);
const handleScroll = () => {
    // Don't handle scroll events triggered by our own scrolling
    if (isScrollingProgrammatically) return;

    // Find which category is currently in view
    const categoryElements = document.querySelectorAll(".category-section");
    let closestCategory = null;
    let closestDistance = Infinity;

    categoryElements.forEach((element) => {
        const rect = element.getBoundingClientRect();
        const categoryTop = rect.top - headerOffset;
        const categoryId = parseInt(element.dataset.categoryId);

        // Find the category closest to the top of the viewport
        if (Math.abs(categoryTop) < closestDistance) {
            closestDistance = Math.abs(categoryTop);
            closestCategory = categoryId;
        }
    });

    // Update the selected category if we found one in view
    if (
        closestCategory !== null &&
        closestCategory !== selectedCategory.value
    ) {
        selectedCategory.value = closestCategory;
        centerSelectedCategory(closestCategory);
    }
};
const centerSelectedCategory = (categoryId) => {
    nextTick(() => {
        if (slideGroup.value) {
            const index = page.category.findIndex(
                (cat) => cat.id === categoryId
            );
            if (index !== -1) {
                const slideGroupEl = slideGroup.value.$el;
                const slideItems = slideGroupEl.querySelectorAll(
                    ".v-slide-group-item"
                );

                if (slideItems[index]) {
                    const item = slideItems[index];
                    const container = slideGroupEl.querySelector(
                        ".v-slide-group__container"
                    );

                    if (container) {
                        const containerWidth = container.offsetWidth;
                        const itemWidth = item.offsetWidth;
                        const scrollLeft =
                            item.offsetLeft -
                            containerWidth / 2 +
                            itemWidth / 2;

                        container.scrollTo({
                            left: scrollLeft,
                            behavior: "smooth",
                        });
                    }
                }
            }
        }
    });
};

onUnmounted(() => {
    window.removeEventListener("scroll", handleScroll);
    clearTimeout(scrollTimeout);
});
const scrollToCategory = (categoryId, toggle) => {
    // Scroll to the category section
    const element = document.getElementById(`category-${categoryId}`);
    if (element) {
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition =
            elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition - 60,
            behavior: "smooth",
        });
    }
};
function isDilivary() {
    // return true;
    return getCookie("tableId") === "yaIzl8L0g34ZmE3c2fUA";
}
const hoveredItemId = ref(null);
const searchDialog = ref(false);
const callWaiter = ref(false);

const itemsPerRow = ref(Number(localStorage.getItem("itemsPerRow")) || 1);

function toggleItemsPerRow() {
    itemsPerRow.value = itemsPerRow.value === 1 ? 2 : 1;
    localStorage.setItem("itemsPerRow", itemsPerRow.value);
}

function setItemsPerRow(val) {
    itemsPerRow.value = Number(val);
    localStorage.setItem("itemsPerRow", itemsPerRow.value);
}
</script>
<template>
    <v-bottom-sheet v-model="callWaiter">
        <v-card class="pa-8 d-flex flex-wrap justify-center align-center">
            <v-btn variant="tonal" v-for="call in store.joinData" :loading="isWaitingTable" v-if="getCookie('tableId')"
                @click="sendAlert(call)" class="me-1 mt-1">
                <span class="me-2 mt-1">{{
                    call["join_" + localeLang.myPrefix]
                    }}</span>
                <v-icon color="orange">mdi-bell</v-icon>
            </v-btn>
        </v-card>
    </v-bottom-sheet>
    <v-bottom-sheet v-model="localSet">
        <v-card>
            <Lang :dark="true" :languages="page.languages"></Lang>
        </v-card>
    </v-bottom-sheet>
    <v-bottom-sheet max-height="75%" v-model="modelFavorate">
        <v-card class="pa-5 position-relative">
            <v-alert rounded="0" color="appBarColor" style="z-index: 222"
                class="position-fixed w-100 left-0 top-0 right-0">
                {{ t("$vuetify.listFavorites") }}
            </v-alert>
            <v-row class="my-6" dense>
                <v-col :key="item.id" v-for="item in favorites"
                    :class="itemsPerRow === 2 ? 'card-col-compact' : 'card-col-single'"
                    :cols="itemsPerRow === 2 ? 6 : 12" sm="6" md="3" lg="3" xl="3">
                    <Item :item="item" :items-per-row="itemsPerRow" />
                </v-col>
                <v-col v-if="favorites.length == 0" class="text-center">
                    <v-alert class="mt-5" color="grey lighten-2" variant="tonal">
                        {{ t("$vuetify.noFavorites") }}
                    </v-alert>
                </v-col>
            </v-row>
        </v-card>
    </v-bottom-sheet>
    <v-dialog v-model="showOrders" max-width="720px">
        <v-card :loading="loading" class="py-2 pa-0">
            <v-btn class="position-fixed" color="red" style="top: -18px; right: 10px; z-index: 100"
                @click="showOrders = false" :aria-label="t('$vuetify.close')">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <div class="mt-2">
                <v-divider :thickness="3" class="border-opacity-50" color="orderBtn">
                    {{ t("$vuetify.orderList") }}
                </v-divider>
            </div>
            <v-card-text class="py-2 text-start border-b" v-for="(order, key) in store.orders" :key="key">
                <div class="float-start mt-1">
                    <span class="font-weight-bold">{{ order.name }}</span>
                    <span v-if="order.size && typeof order.size === 'string' && order.size.trim() && !order.size.includes('{')" class="text-caption text-medium-emphasis ms-1">/ {{ order.size }}</span>
                    <div v-if="getOrderFlavorText(order, key)" class="text-caption text-purple font-weight-medium mt-1">
                        <v-icon size="14" color="purple" class="me-1">mdi-ice-cream</v-icon>
                        {{ getOrderFlavorText(order, key) }}
                    </div>
                </div>
                <div class="float-end">
                    <v-chip class="mx-1 pt-1" label>
                        {{ t("$vuetify.price") }}
                        {{ formatNumber(order.qty * order.price) }}
                    </v-chip>
                    <v-btn @click="removeOrder(key)" size="x-small" class="me-2" color="red" icon="mdi-delete" :aria-label="t('$vuetify.delete')"></v-btn>
                    <v-btn @click="store.ToOrder(order, -1)" size="x-small" icon="mdi-minus" :aria-label="t('$vuetify.decreaseQty')"></v-btn>
                    <v-chip class="mx-1 pt-1">{{ order.qty }}</v-chip>
                    <v-btn @click="store.ToOrder(order, 1)" size="x-small" icon="mdi-plus" :aria-label="t('$vuetify.increaseQty')"></v-btn>
                </div>
            </v-card-text>
            <v-card-text class="pb-1 pt-0">
                <v-form class="pa-1" v-model="formValid" @submit.prevent="submit">
                    <v-card-text class="pb-1" v-if="store.totalPrice > 0">
                        <v-text-field hide-details="auto" type="text" density="comfortable" :label="t('$vuetify.name')"
                            variant="outlined" v-if="isDilivary()" dir="auto" :rules="nameRules" required
                            v-model="name"></v-text-field>
                        <v-text-field class="my-3" hide-details="auto" type="tel" density="comfortable"
                            :label="t('$vuetify.phone')" variant="outlined" v-if="isDilivary()" dir="ltr"
                            :rules="phoneRules" required v-model="phone"></v-text-field>
                        <v-textarea class="my-3" dir="auto" autocomplete="off" rows="1" v-if="isDilivary()"
                            hide-details="auto" density="compact" v-model="address" variant="outlined"
                            :rules="addressRules" :label="t('$vuetify.address')">
                        </v-textarea>
                        <v-textarea rows="1" dir="auto" hide-details density="compact" v-model="comment"
                            variant="outlined" :label="t('$vuetify.comment')">
                        </v-textarea>
                    </v-card-text>
                    <v-card-text class="pb-1 px-1" v-if="store.totalPrice > 0">
                        <v-row>
                            <v-col class="pb-0 pt-1" cols="12" sm="6">
                                <v-alert v-if="store.totalPrice > 0" density="compact" class="pb-1" label>
                                    {{ t("$vuetify.totalPrice") }}
                                    <span v-if="invoiceData != null" class="mx-1 pt-1">
                                        {{ formatNumber(store.totalPrice) }}
                                    </span>
                                    <span v-else-if="store.totalPrice > 0" class="mx-1 pt-2">
                                        {{ formatNumber(store.totalPrice) }}
                                    </span>
                                </v-alert>
                            </v-col>
                            <v-col class="pb-0 pt-1" cols="12" sm="6">
                                <v-btn :loading="loading" type="submit" block color="pink" variant="elevated"
                                    v-if="store.totalPrice > 0 || comment != ''" class="float-en">{{
                                        t("$vuetify.sendOrder") }}
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-divider class="mt-4 mb-2"></v-divider>
                    </v-card-text>
                </v-form>
                <p class="mt-4">
                    {{ showMsg }}
                    <v-divider class="mt-4 mb-2"></v-divider>
                </p>
                <v-btn variant="tonal" v-for="call in store.joinData" :loading="isWaitingTable"
                    v-if="getCookie('tableId') && getCookie('invoice')" @click="sendAlert(call)" class="me-1 mt-1">
                    <span class="me-2 mt-1">{{
                        call["join_" + localeLang.myPrefix]
                        }}</span>
                    <v-icon color="orange">mdi-bell</v-icon>
                </v-btn>
            </v-card-text>
        </v-card>
    </v-dialog>
    <v-dialog class="overflow-y-auto pa-3" style="height: 70vh" v-model="searchDialog" max-width="720px">
        <v-card class="position-relative">
            <v-btn @click="searchDialog = false" style="left: -8px; top: -8px; z-index: 100" class="position-absolute"
                color="red" icon="mdi-close" :aria-label="t('$vuetify.close')"></v-btn>
            <Filter :initialCategories="page.category"></Filter>
        </v-card>
    </v-dialog>

    <v-app-bar color="appBarColor" dark flat density="comfortable" elevation="5" class="d-print-none px-2">
        <template v-slot:prepend>
            <Link :href="route('home')" class="d-flex align-center text-decoration-none text-white">
                <v-img class="imageLogo ms-1" width="45px" height="45px" rounded
                    :src="`/assets/images/${page.option.ku.logo}`"
                    alt=""></v-img>
                <span class="ms-3 font-weight-bold">{{
                    page.option[localeLang.myPrefix]?.title || page.option.ku?.title
                    }}</span>
            </Link>
        </template>

        <template v-slot:append>
            <v-btn icon variant="tonal" size="small" class="rounded-lg" @click="searchDialog = true" :aria-label="t('$vuetify.search')">
                <v-icon class="rotateIcon">mdi-magnify</v-icon>
            </v-btn>
            <v-btn icon variant="tonal" size="small" class="rounded-lg mx-1" @click="toggleItemsPerRow"
                :aria-label="itemsPerRow === 1 ? t('$vuetify.twoItemsPerRow') : t('$vuetify.oneItemPerRow')"
                :title="itemsPerRow === 1 ? t('$vuetify.twoItemsPerRow') : t('$vuetify.oneItemPerRow')">
                <v-icon class="rotateIcon">{{ itemsPerRow === 1 ? 'mdi-view-grid-outline' : 'mdi-view-agenda-outline' }}</v-icon>
            </v-btn>
            <v-btn icon variant="tonal" size="small" class="rounded-lg" @click="darkStore.toggleMode()" :aria-label="t('$vuetify.darkLight')">
                <v-icon class="rotateIcon">mdi-theme-light-dark</v-icon>
            </v-btn>
            <v-btn icon variant="tonal" size="small" class="rounded-lg ms-1" @click="localSet = true" :aria-label="t('$vuetify.changeLanguage')">
                <v-icon>mdi-web-box</v-icon>
            </v-btn>
        </template>
    </v-app-bar>

    <v-parallax cover :height="`calc(90vh - 56px)`" :src="`/assets/images/${page.option.ku.header_image}`"
        :alt="page.option[localeLang.myPrefix]?.title || t('$vuetify.header')">
        <div style="background: linear-gradient(180deg, rgba(0, 0, 0, 0.72) 0%, rgba(0, 0, 0, 0.88) 100%);"
            class="d-flex flex-column fill-height justify-center align-center text-white">
            <v-avatar class="mx-auto" size="200" rounded="lg">
                <v-img :src="`/assets/images/${page.option.ku.logo}`"
                    alt="" cover></v-img>
            </v-avatar>
            <h5 data-aos="fade-down" data-aos-duration="1000" class="text-h5 font-weight-bold px-5 my-4 text-white text-center" style="text-shadow: 0 2px 8px rgba(0,0,0,0.95);">
                {{ page.option[localeLang.myPrefix].min_about }}
            </h5>
            <p data-aos="fade-down" data-aos-duration="1200" class="text-h6 font-weight-bold text-white mb-2 text-center" style="text-shadow: 0 2px 8px rgba(0,0,0,0.95);">
                {{ page.option[localeLang.myPrefix].address }}
            </p>
            <p data-aos="fade-down" data-aos-duration="1300" class="mt-2 text-h6 font-weight-bold text-white mb-1" dir="ltr" style="text-shadow: 0 2px 8px rgba(0,0,0,0.95);">
                {{ page.option[localeLang.myPrefix].phone1 }}
            </p>
            <p data-aos="fade-down" data-aos-duration="1400" class="text-h6 font-weight-bold text-white mb-0" dir="ltr" style="text-shadow: 0 2px 8px rgba(0,0,0,0.95);">
                {{ page.option[localeLang.myPrefix].phone2 }}
            </p>
        </div>
    </v-parallax>
    <div style="position: fixed; bottom: 60px; left: 12px; z-index: 100">
        <v-badge v-if="favorites.length" color="appBarColor" location="top left" :content="favorites.length">
            <v-btn v-if="favorites.length" color="pink" class="px-0" @click="modelFavorate = true" :aria-label="t('$vuetify.listFavorites')">
                <v-icon class="mx-0">mdi-heart</v-icon>
            </v-btn>
        </v-badge>
    </div>
    <v-btn v-if="!showOrders && store.totalPrice > 0" style="position: fixed; bottom: 20px; right: 10px; z-index: 10000"
        color="orderBtn" class="mx-1" @click="fnShowInvoice()" aria-label="Show Order">
        <v-icon>mdi-basket</v-icon>
        <span class="ms-1 mt-1">{{ t("$vuetify.showOrder") }}</span>
        <span v-if="store.totalPrice > 0" class="ms-1 mt-1">{{
            formatNumber(store.totalPrice)
            }}</span>
    </v-btn>
    <v-btn color="orderBtn" @click="callWaiter = true"
        style="position: fixed; bottom: 20px; right: 10px; z-index: 10000"
        v-else-if="getCookie('invoice') && !callWaiter"
        :aria-label="t('$vuetify.waiter')">
        <v-icon>mdi-bell</v-icon>
    </v-btn>

    <v-dialog v-model="feedbackDialog" scrollable fullscreen>
        <v-btn color="pink-accent-4" @click="feedbackDialog = false; feedbackDialogClosed = true;"
            style="position: absolute; top: 8px; right: 10px; z-index: 10000"
            :aria-label="t('$vuetify.close')">
            <v-icon>mdi-close</v-icon>
        </v-btn>
        <FeedbackForm></FeedbackForm>
    </v-dialog>

    <v-main class="justify-center" style="margin-top: 0px; padding-top: 0">
        <div ref="cateTop"></div>
        <v-alert v-if="qrAlert === 'failed'" color="pink-accent-4" class="mx-3 mt-3 mb-0">
            {{ t("$vuetify.qrAlert") }}
        </v-alert>
        <v-alert v-if="pushData != null && pushData.id" :color="pushData.status.color" class="mx-3 mt-2 mb-0">
            {{ pushData.body[localeLang.myPrefix] }}<br />
            <p class="text-sm mt-2 pt-1 border-t" v-if="pushNote">
                {{ pushNote }}
            </p>
        </v-alert>

        <v-sheet class="categories-container" elevation="2" :style="{ top: '56px', position: 'sticky', zIndex: 10 }">
            <v-slide-group v-model="selectedCategory" :show-arrows="false" class="py-1" ref="slideGroup">
                <template v-for="(category, index) in page.category" :key="category.id">
                    <v-slide-group-item v-if="category.items.length > 0" v-slot="{ isSelected, toggle }"
                        :value="category.id">
                        <v-card width="100" height="auto" elevation="0"
                            class="ma-1 py-0 px-0 text-center border justify-center"
                            :color="isSelected ? 'appBarColor' : 'default'"
                            @click="scrollToCategory(category.id, toggle)">
                            <v-img height="70" width="100" v-bind="props" class="float-start overflow-hidden"
                                @error="category.image = page.option.ku.logo" cover
                                :src="`/assets/images/${category.image}`"
                                :alt="category['name_' + localeLang.myPrefix] || category.name_ku || category.name_en || category.name_ar || t('$vuetify.categoryImage')">
                            </v-img>
                            <span style="font-size: 14px">{{
                                category["name_" + localeLang.myPrefix]
                                }}</span>
                        </v-card>
                    </v-slide-group-item>
                </template>
            </v-slide-group>
        </v-sheet>
        <div class="items-container mt-2 px-1 px-sm-3">
            <!-- Items Per Row Switcher Toolbar -->
            <div class="d-flex align-center justify-space-between px-2 mb-3">
                <span class="text-caption font-weight-bold text-medium-emphasis d-flex align-center">
                    <v-icon size="18" class="me-1">mdi-view-dashboard-outline</v-icon>
                    {{ t('$vuetify.itemsPerRow') }}
                </span>
                <v-btn-toggle
                    v-model="itemsPerRow"
                    @update:model-value="setItemsPerRow"
                    mandatory
                    density="compact"
                    color="appBarColor"
                    rounded="lg"
                    class="border"
                >
                    <v-btn :value="1" size="small" class="px-2" :aria-label="t('$vuetify.oneItemPerRow')">
                        <v-icon size="18" class="me-1">mdi-view-agenda-outline</v-icon>
                        <span class="text-caption font-weight-bold">{{ t('$vuetify.singleColumn') }}</span>
                    </v-btn>
                    <v-btn :value="2" size="small" class="px-2" :aria-label="t('$vuetify.twoItemsPerRow')">
                        <v-icon size="18" class="me-1">mdi-view-grid-outline</v-icon>
                        <span class="text-caption font-weight-bold">{{ t('$vuetify.twoColumns') }}</span>
                    </v-btn>
                </v-btn-toggle>
            </div>

            <div v-for="category in page.category" :key="category.id" :id="`category-${category.id}`"
                class="mb-5 category-section" :data-category-id="category.id">
                <v-row v-if="category.items.length > 0" class="justify-center" dense>
                    <v-col cols="12" class="mb-2 pa-1">
                        <v-divider :thickness="3" color="appBarColor" class="border-opacity-75">
                            <h2 class="text-h6">
                                {{ category["name_" + localeLang.myPrefix] }}
                            </h2>
                        </v-divider>
                    </v-col>
                    <v-col v-for="item in category.items" :key="item.id"
                        :class="itemsPerRow === 2 ? 'card-col-compact' : 'card-col-single'"
                        :cols="itemsPerRow === 2 ? 6 : 11"
                        :sm="itemsPerRow === 2 ? 6 : 8"
                        md="3"
                        lg="3"
                        xl="3">
                        <Item :item="item" :items-per-row="itemsPerRow" />
                    </v-col>
                </v-row>
            </div>
        </div>
        <v-divider class="mt-4"></v-divider>

        <div class="d-flex flex-column w-100 align-center text-center justify-center pt-3 px-4">
            <div class="d-flex align-center justify-center flex-wrap">
                <v-btn v-if="page.option[localeLang.myPrefix]?.facebook || page.option.ku?.facebook"
                    tag="a" target="_blank" rel="noopener noreferrer"
                    :href="page.option[localeLang.myPrefix]?.facebook || page.option.ku?.facebook"
                    size="small" icon="mdi-facebook" color="blue" class="my-2 mx-1"
                    :aria-label="t('$vuetify.facebook')">
                </v-btn>
                <v-btn v-if="page.option[localeLang.myPrefix]?.instagram || page.option.ku?.instagram"
                    tag="a" target="_blank" rel="noopener noreferrer"
                    :href="page.option[localeLang.myPrefix]?.instagram || page.option.ku?.instagram"
                    size="small" icon="mdi-instagram" color="orange-lighten-1" class="my-2 mx-1"
                    :aria-label="t('$vuetify.instagram')">
                </v-btn>
                <v-btn v-if="page.option[localeLang.myPrefix]?.tiktok || page.option.ku?.tiktok"
                    tag="a" target="_blank" rel="noopener noreferrer"
                    :href="page.option[localeLang.myPrefix]?.tiktok || page.option.ku?.tiktok"
                    size="small" color="white" class="my-2 mx-1"
                    :aria-label="t('$vuetify.tiktok')">
                    <img width="25" height="25" src="/assets/image/tiktok.svg" alt="" />
                </v-btn>
                <v-btn v-if="page.option[localeLang.myPrefix]?.snapchat || page.option.ku?.snapchat"
                    tag="a" target="_blank" rel="noopener noreferrer"
                    :href="page.option[localeLang.myPrefix]?.snapchat || page.option.ku?.snapchat"
                    size="small" icon="mdi-snapchat" color="yellow" class="my-2 mx-1"
                    :aria-label="t('$vuetify.snapchat')">
                </v-btn>
            </div>
        </div>
        <div class="d-flex flex-wrap justify-center align-center mx-auto mt-1" style="max-width: 350px">
            <a v-if="page.option[localeLang.myPrefix]?.phone1 || page.option.ku?.phone1"
                :href="`tel:${page.option[localeLang.myPrefix]?.phone1 || page.option.ku?.phone1}`"
                class="text-decoration-none"
                aria-label="Phone 1">
                <v-alert class="ma-1 font-en py-2" variant="tonal" color="red-accent-3" dir="ltr">
                    <v-icon>mdi-phone</v-icon>
                    {{ page.option[localeLang.myPrefix]?.phone1 || page.option.ku?.phone1 }}
                </v-alert>
            </a>
            <a v-if="page.option[localeLang.myPrefix]?.phone2 || page.option.ku?.phone2"
                :href="`tel:${page.option[localeLang.myPrefix]?.phone2 || page.option.ku?.phone2}`"
                class="text-decoration-none"
                aria-label="Phone 2">
                <v-alert class="ma-1 font-en py-2" variant="tonal" color="blue" dir="ltr">
                    <v-icon>mdi-phone</v-icon>
                    {{ page.option[localeLang.myPrefix]?.phone2 || page.option.ku?.phone2 }}
                </v-alert>
            </a>
        </div>
        <p class="mt-2 mb-5">
            <a v-if="page.option.ku?.map || page.option[localeLang.myPrefix]?.map"
                target="_blank"
                rel="noopener noreferrer"
                :href="page.option.ku?.map || page.option[localeLang.myPrefix]?.map"
                class="d-inline-flex align-center text-decoration-none">
                <v-icon class="me-1">mdi-map-marker</v-icon>
                <span>{{ page.option[localeLang.myPrefix]?.address || page.option.ku?.address }}</span>
            </a>
            <span v-else class="d-inline-flex align-center text-medium-emphasis">
                <v-icon class="me-1">mdi-map-marker</v-icon>
                <span>{{ page.option[localeLang.myPrefix]?.address || page.option.ku?.address }}</span>
            </span>
        </p>

        <v-footer color="grey-darken-4" elevation="4" class="d-flex flex-column pa-0 text-center justify-center bg-grey-darken-4 text-white">
            <div class="px-4 py-3 text-center w-100">
                <span class="text-caption font-weight-medium text-white">
                    Developed by
                    <a target="_blank" rel="noopener noreferrer" class="text-blue-lighten-3 font-weight-bold text-decoration-none ms-1" href="https://khalcenter.com/">Khal center</a>
                    <v-icon class="mx-1" size="small" color="blue-lighten-3">mdi-code-block-tags</v-icon>
                </span>
            </div>
        </v-footer>
    </v-main>
</template>
<script>
import layout from "../Template.vue";
import FeedbackForm from "@/Components/FeedbackForm.vue";
export default {
    layout: layout,
};
</script>
<style scoped>
.bg-color {
    background-color: rgba(60, 60, 60, 0.8) !important;
    color: #fff !important;
}
.card-col-compact {
    padding: 3px !important;
}
.card-col-single {
    padding: 5px 6px !important;
}
</style>
